jQuery(document).ready(function ($) {
    var count = 0;
    $('#load-more-tips').on('click', function() {
        var button = $(this);
        var page = button.data('page');
        var formerTipsContainer = $('#former-tips-container');
        var upcomingOrFormer = button.data('type'); // Get the type from data attribute
        button.addClass('active'); // Add loading class to button
        button.prop('disabled', true); // Disable the button to prevent multiple clicks

        $.ajax({
            url: script_object.ajax_url,
            method: 'POST',
            dataType: 'json', // Expecting JSON response
            data: {
                action: 'cards',
                function: 'loadMoreTips',
                paged: page, // Sending the current page number
                upcoming_or_former: upcomingOrFormer // Include the type in the request
            },
            success: function (response) {
                button.removeClass('active'); // Remove loading class
                button.prop('disabled', false); // Re-enable the button
                count++;
                console.log(count)
                if (response.success) {
                        // Increment page number for next request
                        button.data('page', page + 1);
                        // Loop through the response data to append new tips
                        var postGroup = $('<div>', { class: 'post-group' });
                        // Ensure to clean up response (strip unwanted newlines and slashes)
                        var tipsContainer = $('<div>', { class: 'tip-secondary-cards' }).html(response.data.data);
                        
                        if( count > 1 ){
                            postGroup.append(tipsContainer);
                        }else{
                            var heading = $('<span>', { class: 'tips_group_label' }).text('Senere innlegg');
                            postGroup.append(heading).append(tipsContainer);
                        }
                        formerTipsContainer.append(postGroup);
                    formerTipsContainer.show();
                } else {
                    alert('Failed to fetch more tips: ' + response.data);
                }
            },
            error: function (xhr, status, error) {
                button.removeClass('loading');
                button.prop('disabled', false);

                console.error('AJAX Error: ' + error);
                alert('There was an error fetching more tips.');
            }
        });
    });
});
